export const VERSION_MIN_FOR_SPLIT = '2.13.3'
export const MOBILE_PAY_SHOW_QR = 'pos_shows_qr'
export const MOBILE_PAY_SCAN_QR = 'pos_scans_qr'
